function toggle(elem) {
  elem.classList.toggle('is-visible');
}

export { toggle }